<template>
  <div>
    <!-- Header -->
    <nav
      id="navMain"
      class="navbar has-shadow is-fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link
          class="navbar-item has-text-weight-semibold logo"
          :to="{ name: 'Home' }"
          >{{ $t("website_title") }}</router-link
        >
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarMain"
          :class="{ 'is-active': collapse }"
          @click.prevent="
            mobile = true;
            collapse = !collapse;
          "
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        id="navbarMain"
        class="navbar-menu"
        v-if="mobile == false || collapse == true"
        :class="{ 'is-active': collapse }"
      >
        <div class="navbar-start">
          <router-link
            class="navbar-item subtitle"
            v-if="loggedIn"
            :to="{ name: 'Member' }"
            >{{ $t("navigation.member") }}</router-link
          >
          <template
            v-for="page in pages.filter(
              (p) => p.parent == 0 && p.slug != 'home' && p.slug != 'notfound'
            )"
          >
            <router-link
              class="navbar-item subtitle"
              v-if="pages.filter((p) => p.parent == page.id).length == 0"
              :key="page.id"
              :to="'/' + $i18n.locale + '/' + page.path"
              ><span @click="collapse = false">{{
                page.title
              }}</span></router-link
            >
            <div
              class="navbar-item has-dropdown is-hoverable"
              :key="page.id"
              v-on:click="hideMenu($event)"
              v-else
            >
              <router-link
                class="navbar-item subtitle"
                :to="'/' + $i18n.locale + '/' + page.path"
                >{{ page.title }}</router-link
              >
              <div class="navbar-dropdown">
                <router-link
                  class="navbar-item subtitle"
                  v-for="subpage in pages.filter((p) => p.parent == page.id)"
                  :key="subpage.id"
                  :to="'/' + $i18n.locale + '/' + subpage.path"
                  ><p v-html="subpage.title"></p
                ></router-link>
              </div>
            </div>
          </template>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <input
              id="switchRoundedOutlinedDefault"
              type="checkbox"
              name="switchRoundedOutlinedDefault"
              class="switch is-thin"
              checked="checked"
              v-model="darkMode"
            />
            <label for="switchRoundedOutlinedDefault"
              >
                <svg
                  class="w-6 h-6 moon"
                  viewBox="0 0 20 20"
                  fill-opacity="1"
                  width="16"
                  height="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                  ></path>
                </svg></label>
          </div>

          <LocaleSwitcher />
          <div class="navbar-item">
            <div class="buttons">
              <router-link
                v-if="!loggedIn"
                :to="{ name: 'Login' }"
                class="button is-fullwidth"
                tag="button"
                >{{ $t("navigation.login") }}
              </router-link>
              <a v-if="loggedIn" href="/" class="button" v-on:click="logout">{{
                $t("navigation.logout")
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <section class="section">
      <div class="container main">
        <!-- Main -->
        <transition name="fade" mode="out-in">
          <router-view :pages="pages" @authState="authState"></router-view>
        </transition>
      </div>
    </section>

    <!-- Footer -->
    <section class="section">
      <div class="container has-text-centered">
        <p class="copyright subtitle is-7" v-html="copyright">
        </p>
      </div>
    </section>
    <footer>
      <cookie-law theme="base" buttonClass="button"></cookie-law>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import LocaleSwitcher from "@/components/LocaleSwitcher";
import CookieLaw from "vue-cookie-law";

export default {
  name: "App",
  data() {
    return {
      collapse: false,
      mobile: false,
      showDropdown: true,
      pages: [],
      title: "",
      loggedIn: false,
      darkMode: true,
      copyright: ""
    };
  },
  components: { LocaleSwitcher, CookieLaw },
  methods: {
    hideMenu(e) {
      var el = e.currentTarget;
      let menu = el.querySelector(".navbar-dropdown");
      let header = el.querySelector(".subtitle");
      menu.style.display = "none";
      this.collapse = false;
      setTimeout(() => {
        el.blur();
        header.blur();
        menu.style.display = "";
      }, 200);
    },
    async getPages() {
      let key = "VUE_APP_API_URL_" + String(this.$i18n.locale).toUpperCase();

      let response = await axios.get(
        process.env[key] + "wp-json/blackdigital/v1/pages"
      );
      var re = new RegExp(
        process.env[key] + "(\\d+)/(\\d+)/(\\d+)/([a-zA-Z-0-9]+)",
        "g"
      );

      response.data.forEach((page) => {
        page.content = page.content.replace(re, "$1/$2/$3/$4");
      });
      this.pages = response.data;
    },
    async getSettings() {
      let key = "VUE_APP_API_URL_" + String(this.$i18n.locale).toUpperCase();

      let response = await axios.get(
        process.env[key] + "wp-json/blackdigital/v1/settings"
      );
      this.title = response.data.name;
      this.copyright = response.data.copyright;
    },
    authState(status, token) {
      localStorage.setItem("token", token);
      if (status == "loggedIn") {
        this.loggedIn = true;
        this.$router.push({ name: "Member" });
      }
    },
    logout() {
      localStorage.clear();
      this.loggedIn = false;
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.loggedIn = true;
    }

    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "light") {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
    else {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    }

    this.getSettings();
    this.getPages();
  },
  watch: {
    darkMode: function () {
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;

      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
};
</script>

<style>
ul.icons li {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}
</style>
